const Events = {
  OPEN_CHAT_BOT: 'OPEN_CHAT_BOT',
  SELECT_CATEGORY: 'SELECT_CATEGORY',
  SELECT_SECTION: 'SELECT_SECTION',
  SELECT_ARTICLE: 'SELECT_ARTICLE',
  SELECT_ARTICLE_FROM_SEARCH: 'SELECT_ARTICLE_FROM_SEARCH',
  SELECT_ARTICLE_FROM_RELATED: 'SELECT_ARTICLE_FROM_RELATED',
  INITIATE_CHAT: 'INITIATE_CHAT',
  SELECT_ACTIVE_CONVERSATION: 'SELECT_ACTIVE_CONVERSATION',
  LOGIN: 'LOGIN',
  INITIATE_VOICE_CHAT: 'INITIATE_VOICE_CHAT',
  INITIATE_OPEN_REQUEST: 'INITIATE_OPEN_REQUEST',
} as const;

type EventList = keyof typeof Events

export interface ReportedEvent {
  operation: string;
  operationTime: string;
  selectionId?: number
}

const now = () => new Date().toISOString();
class Reporting {
  events: ReportedEvent[] = [];

  protected report (...events: Omit<ReportedEvent, 'operationTime'>[]) {
    this.events.push(...events.map(e => ({ ...e, operationTime: now() })));
  }

  selectedActiveConversation (id: number | string) {
    this.selected(Events.SELECT_ACTIVE_CONVERSATION, +id);
  }

  chatBotOpened () {
    this.report({ operation: Events.OPEN_CHAT_BOT });
  }
  selected (event: EventList, selectionId: number) {
    this.report({
      operation: event,
      selectionId,
    });
  }
  selectedCategory (id: number | string) {
    this.selected(Events.SELECT_CATEGORY, +id);
  }
  selectedSection (id: number | string) {
    this.selected(Events.SELECT_SECTION, +id);
  }

  selectedArticle (id: number | string) {
    this.selected(Events.SELECT_ARTICLE, +id);
  }

  selectedArticleFromSearch (id: number | string) {
    this.selected(Events.SELECT_ARTICLE_FROM_SEARCH, +id);
  }

  selectedArticleFromRelated (id: number | string) {
    this.selected(Events.SELECT_ARTICLE_FROM_RELATED, +id);
  }

  chatInitiated () {
    this.report({ operation: Events.INITIATE_CHAT });
  }

  voiceChatInitiated () {
    this.report({ operation: Events.INITIATE_VOICE_CHAT });
  }

  userLoggedIn () {
    this.report({ operation: Events.LOGIN });
  }

  openRequestClicked () {
    this.report({ operation: Events.INITIATE_OPEN_REQUEST });
  }

  getLogs () {
    return this.events;
  }

  reset () {
    this.events = [];
  }
}

export const reportingService = new Reporting();
